import { createAction, props } from "@ngrx/store";
import { CreateOrUpdateExceptionPayloadModel } from "../../models/createOrUpdateExceptionPayloadModel";

export const updateExceptionData = createAction(
    '[Exception] Update existing Exception data on a remark',
    props<{ remarkId: string; exception: CreateOrUpdateExceptionPayloadModel }>()
)

export const createExceptionData = createAction(
    '[Exception] Create new Exception data on a remark',
    props<{ remarkId: string; exception: CreateOrUpdateExceptionPayloadModel }>()
)

export const deleteExceptionData = createAction(
    '[Exception] Delete a existing remark exception',
    props<{ remarkId: string; exceptionId: number }>()
)
